export default {
      id: "sort-usage",
      viewBox: "0 0 15 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#sort",
      toString: function () {
        return this.url;
      }
    }